export * from "./hotel-description.component";
